import React, { Fragment } from "react";
import { Row, Card, CardBody, CardTitle, Progress } from "reactstrap";
import IntlMessages from "Util/IntlMessages";

import { Colxx, Separator } from "Components/CustomBootstrap";
import BreadcrumbContainer from "Components/BreadcrumbContainer";

function progress() {
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <BreadcrumbContainer
              heading={<IntlMessages id="menu.progress" />}
            />
            <Separator className="mb-5" />
          </Colxx>
        </Row>
        <Card className="mb-4">
          <CardBody>
            <CardTitle>
              <IntlMessages id="menu.progress" />
            </CardTitle>
            <Row>
              <Colxx lg="6">
                <p>
                  Progress tag was used and this code was used within Progress
                  bar <code> bar value="15" color="success"</code> value
                  represents progress percentage and color tag was used for
                  color.
                </p>
                <div className="text-center mt-3">0%</div>
                <Progress />
                <div className="text-center mt-3">25%</div>
                <Progress value="25" />
                <div className="text-center mt-3">50%</div>
                <Progress value={50} />
                <div className="text-center mt-3">75%</div>
                <Progress value={75} />
                <div className="text-center mt-3">100%</div>
                <Progress value="100" />
                <div className="text-center mt-3">Multiple bars</div>
                <Progress multi>
                  <Progress bar value="15" />
                  <Progress bar color="success" value="30" />
                  <Progress bar color="info" value="25" />
                  <Progress bar color="warning" value="20" />
                  <Progress bar color="danger" value="5" />
                </Progress>
              </Colxx>
              <Colxx lg="6">
                <p>
                  Progress tag was used and this code was used within Progress
                  bar <code> value="25" color="success"</code> value represents
                  progress percentage and color tag was used for color{" "}
                  <code> className="my-3"</code> only indicates top and bottom
                  margin.
                </p>
                <Progress className="my-3" value={2 * 5} />
                <Progress className="my-3" color="success" value="25" />
                <Progress className="my-3" color="info" value={50} />
                <Progress className="my-3" color="warning" value={75} />
                <Progress className="my-3" color="danger" value="100" />
                <p>Progress bars with texts</p>
                <Progress className="my-3 progressBarThick" value="25">
                  25%
                </Progress>
                <Progress className="my-3 progressBarThick" value={50}>
                  1/2
                </Progress>
                <Progress className="my-3 progressBarThick" value={75}>
                  You're almost there!
                </Progress>
                <Progress
                  className="my-3 progressBarThick"
                  color="success"
                  value="100"
                >
                  You did it!
                </Progress>
                <Progress className="my-3 progressBarThick" multi>
                  <Progress bar value="15">
                    Meh
                  </Progress>
                  <Progress bar className="bg-theme-2" value="30">
                    Wow!
                  </Progress>
                  <Progress bar className="bg-theme-3" value="25">
                    Cool
                  </Progress>
                  <Progress bar className="bg-theme-4" value="20">
                    20%
                  </Progress>
                  <Progress bar color="warning" value="5">
                    !!
                  </Progress>
                </Progress>
              </Colxx>
            </Row>
            <Row>
              <Colxx lg="6">
                <p>
                  Striped Progress bars additionally <code> striped </code> tag
                  was used value represents progress percentage and color tag
                  was used for color.
                </p>
                <Progress striped className="my-3" value={2 * 5} />
                <Progress striped className="my-3" color="success" value="25" />
                <Progress striped className="my-3" color="info" value={50} />
                <Progress striped className="my-3" color="warning" value={75} />
                <Progress striped className="my-3" color="danger" value="100" />
                <Progress className="my-3" multi>
                  <Progress striped bar value="10" />
                  <Progress striped bar color="success" value="30" />
                  <Progress striped bar color="warning" value="20" />
                  <Progress striped bar color="danger" value="20" />
                </Progress>
              </Colxx>
              <Colxx lg="6">
                <p>
                  Stripped Progress bars with texts please use{" "}
                  <code>stripped </code> tag additionally.
                </p>
                <Progress striped className="my-3 progressBarThick" value="25">
                  25%
                </Progress>
                <Progress striped className="my-3 progressBarThick" value={50}>
                  1/2
                </Progress>
                <Progress striped className="my-3 progressBarThick" value={75}>
                  You're almost there!
                </Progress>
                <Progress
                  striped
                  className="my-3 progressBarThick"
                  color="success"
                  value="100"
                >
                  You did it!
                </Progress>
                <Progress className="my-3 progressBarThick" multi>
                  <Progress striped bar value="15">
                    Meh
                  </Progress>
                  <Progress striped bar className="bg-theme-2" value="30">
                    Wow!
                  </Progress>
                  <Progress striped bar className="bg-theme-3" value="25">
                    Cool
                  </Progress>
                  <Progress striped bar className="bg-theme-4" value="20">
                    20%
                  </Progress>
                  <Progress striped bar color="warning" value="5">
                    !!
                  </Progress>
                </Progress>
              </Colxx>
            </Row>
          </CardBody>
        </Card>
      </Fragment>
    );
}

export default progress;
